/**
 * Toggles visibility of exchange list items beyond the default display count.
 * All exchange links remain in the DOM / server-rendered HTML; this only
 * toggles Bootstrap display classes (no network requests, no DOM injection/removal).
 */
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.getElementById("exchangesViewToggleBtn");
  const hiddenExchanges = document.querySelectorAll(".exchange-hidden");

  if (!toggleBtn || hiddenExchanges.length === 0) {
    return;
  }

  let isExpanded = false;

  toggleBtn.addEventListener("click", function () {
    isExpanded = !isExpanded;

    hiddenExchanges.forEach((item) => {
      item.classList.toggle("d-none", !isExpanded);
    });

    toggleBtn.textContent = isExpanded ? "View Less" : "View More";
    toggleBtn.setAttribute("aria-expanded", String(isExpanded));

    if (!isExpanded) {
      const exchangesList = document.getElementById("exchanges-list");
      if (exchangesList) {
        exchangesList.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
});
